import React from "react";
interface dashboardDetailProps {
  name?: any;
  det?: any;
  SVG?: any;
  color?: any;
}
const DashboardCard: React.FC<dashboardDetailProps> = ({
  name,
  det,
  SVG,
  color,
}) => {
  return (
    <div className="dashboard-cart">
      <div className="details">
        <div className="raw1">
          <p className="mainTxt">{name}</p>
         
        </div>
        <div className="raw2">
          <p className="subTxt" >{det}</p>
          <p className="subTxt_container" style={{color:color,borderColor:color}}>{det}%</p>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
